import React, { useEffect } from 'react';
import NavigationBar from "./components/NavigationBar";
import Footer from "./components/Footer";
import './globals.css';

const Accommodation = () => {
  useEffect(() => {
    document.title = "IWPFI2026_Accommodation";
  }, []);
  return (
    <div id="everything">
      <NavigationBar />

      <main className="page-accommodation">
        <section className="accommodation-section">
          <h1 className="accommodation-title">Accommodation</h1>
          <p className="accommodation-text">
            A block of rooms has been reserved at a special group rate. 
            Book early, as availability is limited.
          </p>
          <div className="reg-button-wrapper">
            <a 
              href="https://book.passkey.com/event/51140628/owner/56397/home?lang=en_CA" 
              target="_blank" 
              rel="noopener noreferrer"
              className="reg-button"
            >
              Book your Hotel Room
            </a>
          </div>
        </section>

        {/* Venue title */}
        <h2 className="reg-venue-heading">
          Conference Venue:{" "}
          <a
            href="https://www.fairmont.com/en/hotels/tremblant/fairmont-tremblant.html?goto=fiche_hotel&code_hotel=A565&merchantid=seo-maps-CA-A565&sourceid=aw-cen"
            target="_blank"
            rel="noopener noreferrer"
            className='venue-link'
          >
            Fairmont Tremblant
          </a>
        </h2>
        <p className="reg-text">
          {/* <strong>How to get there:{' '}</strong>
          <a
            href="https://www.fairmont.com/en/hotels/tremblant/fairmont-tremblant/location-contact.html"
            className="reg-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="location-icon">📍</span>
            Location &amp; Contact – Fairmont Tremblant
          </a> */}
          <section className="tremblant-links">
          <h3 className="tremblant-links-title">How to get there:</h3>
          <a
            href="https://www.fairmont.com/en/hotels/tremblant/fairmont-tremblant/location-contact.html"
            className="reg-link"
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="location-icon">📍</span>
            Location &amp; Contact – Fairmont Tremblant
          </a>
          <br></br>
          <br></br>
          <h3 className="tremblant-links-title">From Montréal–Trudeau Airport</h3>
          <strong>Note: September is a very busy season in Mont-Tremblant. Please make your arrangements as soon as possible.</strong>
          <ul className="tremblant-links-list">
            <li>
              <a
                href="https://www.admtl.com/en-CA/parking-and-transport/transport-services/car-rental"
                target="_blank"
                rel="noopener noreferrer"
              >
                Car Rental from the airport
              </a>
            </li>
            <li>
              Pre-arranged ground transportation: To join a group and review transportation options and pricing, 
              please contact Mr. George Banissadi with your flight itinerary at {" "}
            <strong>
              <a href="mailto:westinlimousine@gmail.com">
                westinlimousine@gmail.com 
              </a>
            </strong>
            </li>
          </ul>
          </section>
          <section className="tremblant-links">
          <h3 className="tremblant-links-title">Things to do in Mont-Tremblant</h3>
          <ul className="tremblant-links-list">
            <li>
              <a
                href="https://www.tremblant.ca/things-to-do"
                target="_blank"
                rel="noopener noreferrer"
              >
                Activities | Tremblant
              </a>
            </li>
            <li>
              <a
                href="https://www.tremblant.ca/dining"
                target="_blank"
                rel="noopener noreferrer"
              >
                Restaurants, Bars &amp; Cafés | Tremblant
              </a>
            </li>
            <li>
              <a
                href="https://www.tremblant.ca/things-to-do/shopping"
                target="_blank"
                rel="noopener noreferrer"
              >
                Shopping | Tremblant
              </a>
            </li>
          </ul>
        </section>
        </p>
        
        {/* Tremblant hero image */}
        <img 
          src="./images/Tremblant_Fall.jpg" 
          alt="Mont Tremblant" 
          className="reg-hero-image"
        />
        
        {/* Venue title */}
        {/* <h2 className="reg-venue-heading">Conference Venue: Fairmont Tremblant</h2> */}

        {/* Venue description */}
        {/* <p className="reg-text">
          Our event will be hosted at the Fairmont Tremblant in the beautiful Mont-Tremblant, Quebec, Canada.
          <br/><br/>
          For more information about the venue, visit their website here:
        </p> */}

        {/* Button link */}
        {/* <div className="reg-button-wrapper">
          <a 
            href="https://www.fairmont.com/tremblant/#" 
            target="_blank" 
            rel="noopener noreferrer"
            className="reg-button"
          >
            Fairmont Tremblant Website
          </a>
        </div> */}

        <img 
          src="./images/Tremblant_Pink_Sky.jpg" 
          alt="Mont Tremblant Pink Sky" 
          className="reg-hero-image"
        />

        <img 
          src="./images/Tremblant_Aeriel.jpg" 
          alt="Mont Tremblant Aerial" 
          className="reg-hero-image"
        />
      </main>
      

      <Footer />
    </div>
  );
};

export default Accommodation;
